// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---JmOcG","changedRecordsList":"changedRecordsList---JYWg6","changedRecord":"changedRecord---FAjzR"};